import { ITheme, theme } from "../../utils/theme"

export const CardStyle = {
  border: 'none',
  borderBottom: (theme: ITheme) => `1px solid ${theme.palette.grey[200]}`,
  textAlign: 'left',
  display: 'block',
  paddingRight: 2,
  paddingLeft: 2,
  '&.High': {
    background: theme.palette.red[350],
    ' .MuiTypography-root': {
      color: theme.palette.red[850],
    },
  },
  '&.Normal': {
    background: theme.palette.yellow[600],
  },
  '&.Low': {
    background: theme.palette.oceanicGreen,
  },
  ' .MuiTypography-root': {
    color: theme.palette.corporateBlue,
    textAlign: 'left'
  },
  '&.hidden': {
    display: 'none'
  },
  '&:last-of-type': {
    borderBottom: 'none'
  }
}

export const TitleStyle = {
  fontWeight: 'bold',
}

export const TextStyle = {
  color: (theme: ITheme) => theme.palette.grey.A200,
  overflow: 'hidden',
  textOverflow: 'ellipses',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 3,
  transitionDuration: '0.5s',
  transitionTimingFunction: 'ease-out',
  '&.expanded': {
    textOverflow: 'initial',
    display: 'block',
  }
}

export const ActionsStyle = {
  justifyContent: 'flex-end',
}
